import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function update(tabla) {
    if(tabla.rows==null){
        tabla.rows=[];
    }
  return {type: types.UPDATE_TABLA, tabla};
}
